import type { EstimateOption } from "../api/pricing";
import type {
  FundRequestPayoutInput,
  FundRequestPayoutMethod,
} from "../api/fund-request";
import type { IRequestDraft } from "../store/useRequestStore";
import { resolveAuthoritativeDestinationCurrency } from "./destinationOptions";

export interface BuildRequestDraftInput {
  sourceCountry: string;
  destinationCountry: string;
  sourceCurrency: string;
  /** Compose-screen currency — used only when no option is bound. */
  destinationCurrency: string;
  /** Amount the requester wants to receive (receive-anchored). */
  amount: number;
  payoutMethod: FundRequestPayoutMethod;
  payout: FundRequestPayoutInput;
  /** Pre-quote option the selection priced against, when one matched. */
  option: EstimateOption | null;
}

/**
 * Builds the draft the mint reads. Currency and SKU come from the selected
 * pre-quote option whenever one is bound, so the minted fund-request link is
 * denominated in the currency that was actually priced instead of a stale
 * config / compose-store value.
 */
export const buildRequestDraft = ({
  sourceCountry,
  destinationCountry,
  sourceCurrency,
  destinationCurrency,
  amount,
  payoutMethod,
  payout,
  option,
}: BuildRequestDraftInput): IRequestDraft => {
  const capabilityKey = option?.capabilityKey;
  return {
    sourceCountry,
    destinationCountry,
    sourceCurrency,
    destinationCurrency: resolveAuthoritativeDestinationCurrency(
      option,
      destinationCurrency
    ),
    amount,
    payoutMethod,
    payout,
    ...(capabilityKey ? { capabilityKey } : {}),
  };
};
